import React from 'react';
import { useCurrentEditor } from '@tiptap/react';

import MenuItem from '~/components/core/Atomic/MenuItem';
import Text from '~/components/core/TextComponents/Text';
import DropDownIcon from '~/components/icons/editor/DropDownIcon';
import Popover from '~/components/ui/atoms/Popover';
import usePopoverState from '~/components/ui/atoms/Popover/usePopoverState';
import cn from '~/Utils/cn';

import ToolbarButton from '../ToolbarButton';

interface FontOption {
  label: string;
  value: string;
}

interface FontComponentProps {
  options: FontOption[];
  defaultOption: string;
  containerClassName?: string;
  isActiveFunc: (value: string) => boolean;
  handleChange: (value: string) => void;
  isEnabledFunc: () => boolean;
  /** Names the popover. The trigger keeps the selected option's text as its name. */
  label: string;
}

const FontComponent: React.FC<FontComponentProps> = ({
  options,
  containerClassName,
  defaultOption,
  handleChange,
  isActiveFunc,
  isEnabledFunc,
  label,
}) => {
  const { triggerProps, popoverProps, close } = usePopoverState();
  const { editor } = useCurrentEditor();

  const disabled = !editor?.isEditable || !isEnabledFunc();

  const currentActive = options.find(({ value }) => isActiveFunc(value));

  return (
    <>
      <ToolbarButton disabledHoverEffect disabled={disabled} {...triggerProps}>
        <div className={cn('inline-flex items-center justify-between', containerClassName)}>
          <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM} className="truncate">
            {currentActive?.label || defaultOption}
          </Text>
          <DropDownIcon className="ml-4 min-w-fit" size={12} />
        </div>
      </ToolbarButton>
      <Popover {...popoverProps} aria-label={label} align="start">
        {options.map((option) => (
          <MenuItem
            key={option.label}
            value={option.value}
            onClick={() => {
              handleChange(option.value);
              close();
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};

export default FontComponent;
